<template>
  <div class="index">

    <div class="index-banner">
      <div class="baner-box">
        <el-carousel height="448px" :interval="5000" :indicator-position="bannerList.length>1 ? '' : 'none'">
          <el-carousel-item v-for="(item,index) in bannerList" :key="index">
            <el-image :src="$imgUrl+ item.imageUrl" fit="cover" @click="bannerClick(item)" class="cupo"
              style="width: 100%;" />
          </el-carousel-item>
        </el-carousel>
      </div>
    </div>

    <div class="big-bg">
      <div class="w1200">
        <div class="" style="height: 25px;"> </div>

        <div class="hod-zx over" style="margin-left: -6px;">
          <div class="dis-le fl dis" style="margin-top: 10px;">
            <el-image src="/static/imgs/san.png" fit="cover" class="san" />
            <span class="hot-cla">资讯热点</span>

          </div>
          <div class="dis-ri fl dis" ref="scrollContainer" style="margin-left: 15px;">
            <a class=" dis-ri-list" v-for="(news,index) in newsBox2" :key="index" style="display: block;"
              :href="'/news/article/' + news.id">
              <a class="lalalas" @mouseover="pauseScroll" @mouseleave="resumeScroll">{{news.translations[0].title}}</a>
              <span class="dis-ri-list-l">{{ news.date_created.split('-')[1] + '-' + news.date_created.split('-')[2]}}
              </span>
            </a>
          </div>
        </div>

        <div class="dis" style="margin-left: -6px;">
          <div class="fabu over">
            <div class="fabu-l fl">
              <div class="over mt30s">
                <span class="fl wym">我要买木材</span>
                <!-- <el-image src="/static/imgs/xqimn.png" fit="cover" class="fl xqimn" /> -->

              </div>

              <div class="over">
                <div class="fl qgnum">
                  本月求购数
                </div>
                <div class="fl redtxt">
                  <span class="bigred">{{qgNum}}</span><span class="smallred">个</span>
                </div>

              </div>

            </div>
            <div class="fabu-r fr over" @click="open(0)">
              <el-image src="/static/imgs/wenben1.png" fit="cover" class="fl wenben1" />
              <span class="fabus fl">发布求购</span>
              <el-image src="/static/imgs/you.png" fit="cover" class="fl you" />
            </div>
          </div>
          <div class="fabu over">
            <div class="fabu-l fl">
              <div class="over mt30s">
                <span class="fl wym">我要卖木材</span>
                <!-- <el-image src="/static/imgs/gyimg.png" fit="cover" class="fl xqimn" /> -->
              </div>
              <div class="over">
                <div class="fl qgnum">
                  本月供应数
                </div>
                <div class="fl redtxt">
                  <span class="bigred">{{gyNum}}</span><span class="smallred">个</span>
                </div>
              </div>
            </div>
            <div class="fabu-r fr over" @click="open(1)">
              <el-image src="/static/imgs/wenben2.png" fit="cover" class="fl wenben1" />
              <span class="fabus fl">发布供应</span>
              <el-image src="/static/imgs/you.png" fit="cover" class="fl you" />
            </div>
          </div>
        </div>


        <div class="hot-qg">
          <div class="qg-pading">
            <div class="list-title dis list-titleaaa">
              <div class="dis"><img src="/static/imgs/rmqg.png" fit="cover"
                  style="width: 28px;height: 28px;margin-left: 7px;" /><span class="hot-wight">热门求购</span></div>
              <div class="dis">
                <div class="dis">
                  <div v-for="(item,index) in varBox" :key="index" v-if="index<7"
                    :class="['hot-txt cupo',qgIndex == index ?'hot-avtive':'']" @click="qgClick(index,item)">
                    {{!index?'热门': item.itemValue}}
                  </div>
                </div>
                <div class="see-more cupo dis" @click="see(0)">查看更多
                  <div class="imgdiv"></div>
                </div>
              </div>
            </div>

            <div class="data-list over" v-loading="qgLoading" style="min-height: 322px;margin-left: -6px;">

              <a v-for="(item,index) in qgBox" :key="index"
                :href="'/demand/seekarticle/id/'+item.id +  '/member/' + item.creatorId + '/company/' + item.companyId"
                style="display: block;" :class="['hot-list cupo fl',(index+1)%4 === 0 ?'hot-mr0':'hot-mr']"
                v-if="item.id">
                <div class="box-pading">
                  <p class="jx dis"><el-image
                      :src="'/static/imgs/'+ datms.qgTag.find((items) => items.val == item.tagId).img" fit="cover"
                      style="width: 39px;height: 16px;padding-right: 5px;" v-if="item.tagId" /><span
                      class="list-tit clamp1" style="width: 200px;">{{item.title}}</span>
                  </p>
                  <p class="shd">收货地：{{item.addressDisplay || '不限'}}</p>
                  <p class="sl">求购数量：<span class="red-wight">{{item.quantity || '不限'}}

                      <span class="col" v-if="item.quantity && item.unitName">{{' ' + item.unitName}}</span>

                    </span></p>
                  <div class="dis">
                    <p class="dis">
                      <el-image
                        :src="item.displayHeadImage ? $imgUrl + item.displayHeadImage  : '/static/imgs/dimg.png'"
                        fit="cover" style="width: 20px;height: 20px;border-radius: 100%;" />
                      <span class="my clamp1">{{ item.isAuth ? item.companyName : item.displayName}}</span>
                    </p>
                    <p class="rq clamp1">{{item.createDate.split(" ")[0]}}</p>
                  </div>
                </div>

                <div class="list-black" v-if="item.black">
                  <div style="margin-top: 10px;">
                    <canvas id="QRCode_header"></canvas>
                  </div>
                  <span class="saoma">扫码立刻报价</span>
                </div>
                <el-image src="/static/imgs/ycj.png" fit="cover" class="ycjico" v-if="item.status == 2" />
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>



    <div class="hot-qg-bg">
      <div class="qg-pading-aas">
        <div class="list-title dis">
          <div class="dis"><el-image src="/static/imgs/rmgy.png" fit="cover"
              style="width: 28px;height: 28px;margin-left: 7px;" /><span class="hot-wight">热门供应</span></div>
          <div class="dis">
            <div class="dis">
              <div v-for="(item,index) in varBox" :key="index" v-if="index<7"
                :class="['hot-txt cupo',gyIndex == index ?'hot-avtive':'']" @click="gyClick(index,item)">
                {{!index?'热门': item.itemValue}}
              </div>
            </div>
            <div class="see-more cupo dis" @click="see(1)">查看更多
              <div class="imgdiv" style="margin-right: 6px;"></div>



            </div>
          </div>
        </div>
        <div :class="['data-list over',gyBox.length?'p-20':'p-0']" v-loading="gyLoading" style="min-height: 322px;">
          <div v-if="!gyShow">

            <a v-for="(item,index) in gyBox" :key="index"
              :href="'/demand/supplyarticle/id/'+item.id +  '/member/' + item.creatorId + '/company/' + item.companyId"
              :class="['hot-list-gy fl',(index+1)%5 === 0 ?'hot-mr0-gy':'hot-mr-gy']">
              <div style="width: 214px;margin: 0 auto;">
                <div class="img-box-gy cupo">
                  <el-image
                    :src="$imgUrl + (item.supplyAdvPictures[0].pictureUrl.includes('.mp4') ? item.supplyAdvPictures[1].pictureUrl : item.supplyAdvPictures[0].pictureUrl)"
                    fit="cover" style="width: 100%;height: 100%;border-radius: 12px;margin-top: 5px;" />
                  <div class="list-black" style="border-radius: 0;" v-if="item.black">
                    <div style="margin: 36px auto 6px;">
                      <canvas id="QRCode_header"></canvas>
                    </div>
                    <span class="saoma">扫码查看详情</span>
                  </div>
                </div>

                <div class="box-pading">
                  <div class="jx dis " style="margin-bottom: 10px;margin-top: 6px;"><el-image
                      :src="'/static/imgs/'+ datms.gyTag.find((items) => items.val == item.tagId).img" fit="cover"
                      style="width: 39px;height: 16px;padding-right: 5px;" v-if="item.tagId" />
                    <p class="list-tit clamp1" style="font-weight: 400;color: #333;">{{item.description}}</p>
                  </div>
                  <p class="dis" style="justify-content: flex-start;">
                    <el-image :src="item.userHeadUrl ? $imgUrl + item.userHeadUrl  : '/static/imgs/dimg.png'"
                      fit="cover" style="width: 20px;height: 20px;border-radius: 100%;" />
                    <span class="my clamp1" style="color: #848691;font-size: 12px;">{{item.creatorName}}</span>
                  </p>
                  <div class="dis " style="margin-top: 10px;font-size: 12px;color: #848691;">
                    <p class="clamp1">
                      <i class="el-icon-location-outline" style="font-size: 14px;"></i> {{item.shipProvinceName}}
                      {{item.shipCityName}}
                    </p>
                    <p class="rq clamp1" style="color:#848691 ;">{{item.createDate.split(' ')[0]}}</p>
                  </div>
                  <p style="margin-top: 6px;  color: #f22424;">
                    <span style="font-weight: bold;font-size: 12px;" v-if="item.specPrice != -1 ">￥</span> <span
                      class="red-wight-2">{{item.specPrice == -1 ?'电议':item.specPrice}}</span><span
                      style="font-size: 12px;" v-if="item.specPrice != -1 ">/{{item.unitName}}</span>
                  </p>
                </div>
              </div>
            </a>
          </div>

          <div v-else class="dis" style="width: 388px;margin: 30px auto 0 auto;">
            <el-image src="/static/imgs/emp.png" fit="cover" style="width: 200px;height: 200px;" />
            <span class="bq">抱歉，没有找到相关供应</span>
          </div>

        </div>
      </div>
    </div>

    <!-- 广告 -->
    <div class="adve over">
      <div :class="['adve-list fl',(index+1)%4 === 0 ?'gg-mr0':'gg-mr']" v-for="(item,index) in ggBox" :key="index">
        <el-image :src="$imgUrl + item.imageUrl" fit="cover" style="width: 100%;height: 100%;" class="aaa" />
      </div>
    </div>


    <div class="marke dis">
      <div class="hq-list">
        <div class="hq-list-pad">

          <div class=" dis" style="margin-bottom: 17px;">
            <div class="dis"><el-image src="/static/imgs/mc.png" fit="cover" style="width: 28px;height: 28px;" /><span
                class="hot-wight">木材行情</span></div>
            <div class="see-more cupo dis" @click="$router.push({path: '/market'})">查看更多
              <div class="imgdiv" style="margin-right: 0;"></div>



            </div>
          </div>
          <div class="hq-type dis">
            <div class="dis hq-type-box">
              <div :class="['hq-type-box-c',index==0 ? 'tap-active left2':'right2']" v-for="(item,index) in datms.tap"
                :key="index">{{item.name}}</div>
            </div>

            <div class="dis">

              <div v-for="(item,index) in cityBox" :key="index"
                style="margin-right: 0;margin-left: 20px;font-size: 14px;padding-bottom: 7px;"
                :class="['hot-txt cupo',cityIndex == index ?'hot-avtive ':'']" @click="cityClick(index,item)">
                {{item.itemValue}}
              </div>

            </div>
          </div>
          <div style="overflow-y: hidden;position: relative;height: 275px;">
            <div v-loading="markLoading" @mouseover="pauseScrollpas" class="dakaka"
              :style="{top:listTop + 'px'}" @mouseleave="resumeScrollpas">
              <router-link class="mon-list dis cupo" v-for="(item,index) in pastBox" :key="index"
                :to="'/market/article/' + item.id">
                <div><span class="hq-jz">【建筑木方】</span>{{item.title}}</div>
                <div class="hq-riq">{{item.market_date}}</div>
              </router-link>
            </div>
          </div>
        </div>
      </div>

      <div class="people">
        <div class="peo-box">
          <div class="dis" style="justify-content: flex-start;margin-bottom: 17px;"><el-image src="/static/imgs/kf.png"
              fit="cover" style="width: 24px;height: 24px;" /><span class="hot-wight">金牌客服</span></div>

          <div style="width: 320px;margin: 0 auto;">
            <el-carousel :interval="4000" type="card" height="280px" trigger="click" width="200px" arrow="always"
              @change="carChange">
              <el-carousel-item v-for="(item,index) in peoBox" :key="index">
                <div style="position: relative;">
                  <div class="posres">
                    <el-image class="aaa" :src="item.prefix +item.avatar.filename_disk" fit="fill"
                      style="height: 100%;width: 100%;" />
                    <div class="xiangy">平均响应 {{item.response_time}}</div>
                  </div>
                  <div class="bgf">
                    <div class="bgf-pad">
                      <div class="n1">{{item.name}}</div>
                      <div class="n2 clamp2" style="width: 100%;">擅长：{{item.skills}}</div>
                      <div class="n3 ">
                        <el-image class="fl icoimg" src="/static/imgs/vx@2x.png" fit="cover"
                          style="height: 22px;width: 22px;margin-right: 5px;" @mouseenter='mouseenters(0,item,index)'
                          @mouseleave="visible = false" />
                        <el-image class="fl icoimg" src="/static/imgs/dianhua@2x.png" fit="cover"
                          style="height: 22px;width: 22px;" @mouseenter='mouseenters(1,item,index)'
                          @mouseleave="visible = false" />
                      </div>
                    </div>
                  </div>
                  <div class="mengban" v-if="index!=peoIndex"></div>
                </div>

              </el-carousel-item>
            </el-carousel>
          </div>

          <div :class="['showdiv',peoimgInd ? 'top0' : 'top85']">
            <el-popover trigger="hover" v-model="visible" placement="top-start">
              <p v-show="peoimgInd">{{peoPhone}}</p>
              <el-image class="erimg" :src="peoimgUrl" fit="contain" v-show="!peoimgInd" />
            </el-popover>
          </div>
        </div>
      </div>
    </div>

    <div class="index-news">
      <div class="news-pad">
        <div class="dis" style="justify-content: flex-start;"><el-image src="/static/imgs/xw.png" fit="cover"
            style="width: 24px;height: 24px;"></el-image><span class="hot-wight">新闻动态</span>
        </div>
        <div class="news-box dis">

          <router-link class="nes-l cupo" v-for="(item,index) in newsBox" :key="index" v-if="!index"
            style="display: block;" :to="'/news/article/' + item.id">
            <div class="news-i">
              <el-image :src="item.prefix + item.image.filename_disk" fit="cover"
                style="height: 370px;width: 100%;border-radius: 12px;" class="aaa"></el-image>
            </div>
            <p class="news-p1 clamp1">{{item.translations[0].title}}</p>
            <p class="news-p2">{{item.date_created}}</p>

          </router-link>
          <div class="nes-r">

            <router-link :class="['news-list cupo',index==1?'borno':'bor1']" v-for="(item,index) in newsBox"
              style="display: block;" :key="index" :to="'/news/article/' + item.id" v-if="index&&index<6">
              <div :class="['news-list-tit clamp1',index==1?'gino':'gino1']">
                {{item.translations[0].title}}
              </div>
              <div class="news-list-rq">
                {{item.date_created}}
              </div>
            </router-link>
          </div>
        </div>
        <div class="news-btn cupo" @click="$router.push({path:'/news'})">
          更多新闻动态
        </div>
      </div>
    </div>

    <div class="tuijian dis">

      <div class="tuijian-list dis">
        <el-image src="/static/imgs/zh.png" fit="cover" style="height: 76x;width: 76px;margin-right: 23px;"></el-image>
        <div>
          <p class="tuijian-tit">免费找货</p>
          <p class="tuijian-txt">强大的集采服务</p>
        </div>
      </div>

      <div class="tuijian-list dis">
        <el-image src="/static/imgs/qu.png" fit="cover" style="height: 76x;width: 76px;margin-right: 23px;"></el-image>
        <div>
          <p class="tuijian-tit">10000+工厂</p>
          <p class="tuijian-txt">覆盖全国木业聚集区域</p>
        </div>
      </div>
      <div class="tuijian-list dis">
        <el-image src="/static/imgs/jy.png" fit="cover" style="height: 76x;width: 76px;margin-right: 23px;"></el-image>
        <div>
          <p class="tuijian-tit">平台交易</p>
          <p class="tuijian-txt">可视化交易，全程在线跟踪</p>
        </div>
      </div>
      <div class="tuijian-list dis">
        <el-image src="/static/imgs/zj.png" fit="cover" style="height: 76x;width: 76px;margin-right: 23px;"></el-image>
        <div>
          <p class="tuijian-tit">专业质检</p>
          <p class="tuijian-txt">现场看货，专业质检</p>
        </div>
      </div>
    </div>



    <div class="bom-div" v-if="bomShow">
      <div :class="['div-bg',fbi ? 'gy' : 'qg']">
        <div style="padding:72px 0 6px 0 ;"><canvas id="QRCode_header"></canvas></div>
      </div>
      <el-image src="/static/imgs/close.png" fit="cover" style="width: 60px;height: 60px;padding-top: 22px" class="cupo"
        @click="bomShow = false" />

    </div>





  </div>
</template>

<script>
  export default {

    name: 'Index',
    data() {
      return {
        qgNum: '',
        gyNum: '',
        fbi: 0,
        bomShow: false,
        animateUp: false,

        newsBox2: [],
        qgIndex: 0,
        gyIndex: 0,
        cityIndex: 0,
        bannerList: [],
        cityBox: [],
        qgBox: [],
        qgObj: {
          page: 1,
          limit: 8,
          categoryId: ''
        },
        varBox: [],
        gyBox: [],
        gyObj: {
          page: 1,
          limit: 5,
          categoryIds: ''
        },
        pastBox: [],
        peoIndex: 0,
        peoBox: [],
        peoimgUrl: '',
        visible: false,
        peoimgInd: 0,
        peoPhone: '',
        newsBox: [],
        qgLoading: true,
        gyLoading: true,
        markLoading: false,
        ggBox: [],
        gyShow: false,
        scrollInterval: null,
        scrollIntervalDiv: null,
        listTop: 0


      }
    },
    watch: {
      $route(to, from) {
        if (this.scrollInterval) {
          clearInterval(this.scrollInterval); // 清除之前的滚动定时器
        }
        if (this.scrollIntervalDiv) {
          clearInterval(this.scrollIntervalDiv); // 清除定时器，防止内存泄漏
        }
        this.autoScroll(); // 路由跳转后重新启动滚动
        this.autoScrollDiv();
      },
    },

    mounted() {
      this.getAll()
      this.getQg()
      this.getGy()
      this.autoScroll();

      this.autoScrollDiv();

    },

    beforeDestroy() {
      if (this.scrollInterval) {
        clearInterval(this.scrollInterval); // 清除定时器，防止内存泄漏
      }
      if (this.scrollIntervalDiv) {
        clearInterval(this.scrollIntervalDiv); // 清除定时器，防止内存泄漏
      }

    },
    methods: {

      autoScrollDiv() {


        this.scrollIntervalDiv = setInterval(() => {
          this.listTop -= 1

          if (this.listTop == -34) {
            this.pastBox.push(this.pastBox.splice(0, 1)[0])
            this.listTop = 0
          }
        }, 50);
      },


      autoScroll() {
        const container = this.$refs.scrollContainer;

        let scrollSpeed = 1; // 调整滚动速度

        this.scrollInterval = setInterval(() => {
          if (container.scrollLeft >= container.scrollWidth - container.clientWidth) {
            container.scrollLeft = 0; // 回到开头
          } else {
            container.scrollLeft += scrollSpeed; // 向右滚动
          }

        }, 30);
      },

      pauseScroll() {
        if (this.scrollInterval) {
          clearInterval(this.scrollInterval); // 停止滚动
        }
      },
      resumeScroll() {
        this.autoScroll(); // 恢复滚动
      },
      pauseScrollpas() {
        if (this.scrollIntervalDiv) {
          clearInterval(this.scrollIntervalDiv); // 停止滚动
        }

      },
      resumeScrollpas() {
        this.autoScrollDiv();
      },


      open(num) {
        this.fbi = num

        let str = num ? 'fbgyline' : 'fbqgline'
        this.useqrcode(str, {
          link: 'index',
          soucus: 'web',
          channelType: '4'
        }, 200, 200)
        this.bomShow = true
      },

      getCity(code) {
        this.markLoading = true
        this.$request('get', this.$otapi +
          'items/market?page=1&limit=15&filter={"status": "published","city_id":' + code + '}&sort=-date_created', {},
          (
            res) => {
            if (res.status == 200) {
              this.pastBox = res.data.data
              this.markLoading = false
            } else {
              this.$notify.error({
                title: '错误',
                message: '请求失败，请重试！',
                position: 'top-left'
              });
            }
          })
      },

      getQg() {
        this.$request('get', this.$wxapi + 'buyrequests/trending/page', this.qgObj, (res) => {
          this.qgLoading = true
          if (res.status == 200) {
            this.qgBox = res.data.data.list
            this.qgLoading = false
          } else {
            this.$notify.error({
              title: '错误',
              message: '请求失败，请重试！',
              position: 'top-left'
            });
          }
        })
      },
      seekClick(val, i) {
        this.$router.push({
          name: i ? 'demAndArtSupply' : 'demAndArt',
          params: {
            id: val.id,
            member: val.creatorId,
            company: val.companyId
          }
        });
      },
      getGy() {
        this.$request('get', this.$wxapi + 'supplyproduct/official-site/page', this.gyObj, (res) => {
          this.gyLoading = true
          if (res.status == 200) {
            this.gyBox = res.data.data.list
            this.gyShow = res.data.data.list.length ? false : true
            this.gyLoading = false
          } else {
            this.$notify.error({
              title: '错误',
              message: '请求失败，请重试！',
              position: 'top-left'
            });
          }
        })
      },
      mouseenters(num, val, i) {
        if (this.peoIndex != i) {
          return
        }
        this.visible = true
        this.peoimgInd = num
        if (!num) {
          this.peoimgUrl = val.prefix + val.weChat.filename_disk
        } else {
          this.peoPhone = val.telephone
        }
      },
      gotoRuzhu() {
        this.$router.push({
          path: '/settled'
        });
      },
      listDeta(val) {
        this.$router.push({
          path: '/info/article',
          query: {
            id: val.id,
            tap: 1
          }
        });
      },
      see(i) {
        this.$store.commit('searValue', {
          type: i,
          val: '',
          classify: 0,
          page: 1
        });
        this.$router.push({
          path: '/demand',
        }).catch(err => {
          if (err.name !== 'NavigationDuplicated') {
            console.error(err);
          }
        });
      },
      bannerClick(val) {
        if (!val.relationTarget || val.relationTarget == 'WITHOUT') {
          return
        }
        window.open(val.relationTarget)
      },
      getAll() {

        this.$request('get', this.$wxapi + 'buyrequests/official-site/month/count', {}, (res) => {
          if (res.status == 200) {

            this.qgNum = res.data.data
          } else {
            this.$notify.error({
              title: '错误',
              message: '请求失败，请重试！',
              position: 'top-left'
            });
          }
        })
        this.$request('get', this.$wxapi + 'supplyproduct/official-site/month/count', {}, (res) => {
          if (res.status == 200) {
            this.gyNum = res.data.data

          } else {
            this.$notify.error({
              title: '错误',
              message: '请求失败，请重试！',
              position: 'top-left'
            });
          }
        })


        this.$request('get', this.$wxapi + 'dict/list?dictCode=TIMBER_TYPE', {}, (res) => {
          if (res.status == 200) {
            res.data.data.unshift({
              itemValue: '热门',
              itemCode: ''
            })

            this.varBox = res.data.data
            this.$store.commit('caizhi', this.varBox);
          } else {
            this.$notify.error({
              title: '错误',
              message: '请求失败，请重试！',
              position: 'top-left'
            });
          }
        })
        this.$request('get', this.$wxapi + 'dict/list?dictCode=MARKET_CODE', {}, (res) => {
          if (res.status == 200) {
            this.$store.commit('region', res.data.data);
            this.cityBox = res.data.data
            this.getCity(this.cityBox[0].itemCode)
          } else {
            this.$notify.error({
              title: '错误',
              message: '请求失败，请重试！',
              position: 'top-left'
            });
          }
        })

        this.$request('get', this.$wxapi + 'portaladv/official-site/page', {
          page: 1,
          limit: 8
        }, (res) => {
          if (res.status == 200) {
            this.ggBox = res.data.data.list
          } else {
            this.$notify.error({
              title: '错误',
              message: '请求失败，请重试！',
              position: 'top-left'
            });
          }
        })

        this.$request('get', this.$otapi +
          'items/articles?page=1&limit=6&meta=*&fields=category&fields=id&fields=translations.title&filter={"status":"published"}&sort=-date_created&fields=image.filename_disk&fields=prefix&fields=date_created&sort=-id', {},
          (
            res) => {
            if (res.status == 200) {
              this.newsBox = res.data.data
            } else {
              this.$notify.error({
                title: '错误',
                message: '请求失败，请重试！',
                position: 'top-left'
              });
            }
          })

        this.$request('get', this.$otapi +
          'items/articles?page=1&limit=10&meta=*&fields=category&fields=id&fields=translations.title&filter={"status":"published"}&sort=-date_created&fields=image.filename_disk&fields=prefix&fields=date_created&sort=-id', {},
          (
            res) => {
            if (res.status == 200) {
              this.newsBox2 = res.data.data
            } else {
              this.$notify.error({
                title: '错误',
                message: '请求失败，请重试！',
                position: 'top-left'
              });
            }
          })
        this.$request('get', this.$otapi + 'items/salesman_profile?fields=*.*', {}, (res) => {
          if (res.status == 200) {
            this.peoBox = res.data.data
          } else {
            this.$notify.error({
              title: '错误',
              message: '请求失败，请重试！'
            });
          }
        })

        this.$request('get', this.$wxapi + 'operation/index/advPage', {
          scene: 1
        }, (res) => {
          if (res.data.code == 200) {
            this.bannerList = res.data.data.list
          } else {
            this.$notify.error({
              title: '错误',
              message: '请求失败，请重试！'
            });
          }
        })
      },

      carChange(e) {
        this.peoIndex = e
      },
      qgClick(i, vals) {
        this.qgIndex = i
        this.qgObj.categoryId = vals.itemCode
        this.getQg()
      },

      gyClick(i, vals) {
        this.gyIndex = i
        this.gyObj.categoryIds = vals.itemCode
        this.getGy()
      },
      cityClick(i, val) {
        this.cityIndex = i
        this.getCity(val.itemCode)
      },
      indexMore() {
        this.$router.push({
          path: '/index/indexInfo'
        });
      }
    },
    metaInfo() {
      return {
        title: '聚木网-专注于木材交易的互联网平台'
      }
    }
  }
</script>
<style scoped>
  @import url('../../../static/css/index.css');
</style>



// WEBPACK FOOTER //
// src/components/index/index.vue